import { showBuildInfoBadge, startApp } from "./app";

void startApp();
void showBuildInfoBadge();
